const MENU_TYPES = {
    PROFILE: "profile",
    DETAIL: "detail",
    VISIBILITY: "visibility",
    WALLET: "wallet",
    NEW_TEMPLATE: "new-template",
    TEMPLATES: "templates",
    BROADCAST_REQUESTS: "broadcast-requests",
    CUSTOMER_GROUPS: "customer-groups",
    NUMBERS: "numbers",
    VOICE_CONFIGURATION: "voice-configuration",
    META_INSIGHTS: "meta-insights",
    AD_OPTIMIZATION: "ad-optimization",
    COMPARISON: "comparison",
    MOVEMENTS: "movements",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.PROFILE,
        label: that?.$t("multi_whatsapp_api.profile") || "Profile",
        icon: {
            type: "material-icons",
            name: "badge",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("multi_whatsapp_api.detail") || "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.WALLET,
        label: that?.$t("settings.wallet") || "Wallet",
        icon: {
            type: "material-icons",
            name: "account_balance_wallet",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.NEW_TEMPLATE,
        label: that?.$t("multi_whatsapp_api.new_template") || "New Template",
        icon: {
            type: "material-icons",
            name: "newspaper",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.TEMPLATES,
        label: that?.$t("multi_whatsapp_api.templates") || "Templates",
        icon: {
            type: "material-icons",
            name: "description",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.BROADCAST_REQUESTS,
        label: that?.$t("multi_whatsapp_api.broadcast_requests") || "Broadcast Requests",
        icon: {
            type: "material-icons",
            name: "podcasts",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.CUSTOMER_GROUPS,
        label: that?.$t("multi_whatsapp_api.customer_groups") || "Customer Groups",
        icon: {
            type: "material-icons",
            name: "group_add",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VOICE_CONFIGURATION,
        label: "Voice Configuration",
        icon: {
            type: "material-icons",
            name: "dialer_sip",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.META_INSIGHTS,
        label: "Meta Insights",
        icon: {
            type: "material-icons",
            name: "insights",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.AD_OPTIMIZATION,
        label: "Ad Optimization",
        icon: {
            type: "material-icons",
            name: "campaign",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.COMPARISON,
        label: "WhatsApp Çözümleri Karşılaştırması",
        icon: {
            type: "material-icons",
            name: "compare",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.MOVEMENTS,
        label: "Hesap Hareketleri",
        icon: {
            type: "material-icons",
            name: "receipt_long",
        }
    },
];

export default {
    MENU_TYPES,
    Items,
};
